import { Alert } from "@msuite/ui/alert";
import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";

/** Props Interface */
interface AssignmentReferenceBookingsStaleAlertProps {
	isReloading: boolean;
	onReload: () => void;
}

/**
 * Says that the record changed while the modal was open, so the save was refused, and offers to
 * load the current state — which discards the edits made here, and says so before it does.
 */
export function AssignmentReferenceBookingsStaleAlert({
	isReloading,
	onReload,
}: AssignmentReferenceBookingsStaleAlertProps) {
	/** Context */
	const { t } = useTranslation();

	/** Render */
	return (
		<div className="v-stack gap-2 p-4">
			<Alert
				variant="warning"
				title={t("partners.bookings_changed_title")}
				description={t("partners.bookings_changed_description")}
			/>
			<div className="h-stack justify-end">
				<Button
					icon={<Icon name="RefreshCw" />}
					isLoading={isReloading}
					onClick={onReload}
				>
					{t("partners.reload_bookings")}
				</Button>
			</div>
		</div>
	);
}
